import { render } from "./NewCalls.vue?vue&type=template&id=487876ce&scoped=true"
import script from "./NewCalls.vue?vue&type=script&lang=js"
export * from "./NewCalls.vue?vue&type=script&lang=js"

import "./NewCalls.vue?vue&type=style&index=0&id=487876ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487876ce"]])

export default __exports__